import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  margin: 40px max(8px, calc((100% - 1312px) / 2));
  padding: 24px;

  background: var(--white);
  border-radius: 4px;
`
